import { IScreenDesignContextState } from "../../contexts/screen-design-context/screen-design-context";
import type { ScreenDesignInstance } from "./designer-context";
import { getValues } from "./designer-context";

interface HistoryResult {
  success: boolean;
  message: string;
}

export function undoDesignerChange(sdInstance: ScreenDesignInstance): HistoryResult {
  const sd: IScreenDesignContextState = getValues(sdInstance);
  const screenProvider: IScreenDesignContextState = sd;

  if (!screenProvider?.canUndo?.()) {
    return { success: false, message: "Nothing to undo" };
  }

  screenProvider.undo();
  return { success: true, message: "Undo performed" };
}

export function redoDesignerChange(sdInstance: ScreenDesignInstance): HistoryResult {
  const sd: IScreenDesignContextState = getValues(sdInstance);
  const screenProvider: IScreenDesignContextState = sd;

  if (!screenProvider?.canRedo?.()) {
    return { success: false, message: "Nothing to redo" };
  }

  screenProvider.redo();
  return { success: true, message: "Redo performed" };
}
